import React from 'react';
import { useQuery } from 'react-query';
import { GetCommunityIdeas } from 'services/apiServices';
import { Errors, TCommunityIdeasResult } from 'types/ApiServicesTypes';
import { debounce } from 'lodash';

const WAIT_INTERVAL = 300;

export default function useGetCommunityIdeas(page = 1, pageSize = 10) {
  const [currentPage, setCurrentPage] = React.useState(page);

  const objQuery = useQuery<TCommunityIdeasResult, Errors>(
    ['GetCommunityIdeas', currentPage, pageSize],
    () => GetCommunityIdeas(currentPage, pageSize),
  );

  const { refetch } = objQuery;

  const debouncedRefetch = React.useMemo(() => {
    return debounce(refetch, WAIT_INTERVAL);
  }, [refetch]);

  // If the page changes, refetch the data
  React.useEffect(() => {
    void refetch();
  }, [currentPage, refetch]);

  return {
    ...objQuery,
    currentPage,
    setCurrentPage,
  };
} 